import { NavigateNext } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

import Button from 'domains/core/components/Button';
import { Folder } from 'models/types';
import theme from 'theme';

import ModalItem from '../ModalItem';

const border = `1px solid ${theme.palette.primary.main}`;

const breadcrumbWrapperStyles = {
    padding: '0.5rem 1.5rem',
    borderTop: `1px solid ${theme.palette.primary.main}`,
};

const activeBreadcrumbStyles = {
    color: theme.palette.action.active,
    padding: 1,
};

const contentWrapperStyles = {
    borderTop: border,
    padding: '1rem 1rem 0',
};

type Props = {
    data: Folder[];
    previewedLocation: Folder;
    resetPreview: () => void;
    rootFolder: Folder;
};

const ModalPreviewItem = ({ data, previewedLocation, resetPreview, rootFolder }: Props) => {
    const getDomainName = (name: string) => String(name).split(' ')[1].toLowerCase();

    const renderModalItems = () => {
        if (!data?.length) {
            return (
                <Typography align="center" sx={{ padding: '1rem' }} variant="body2">
                    No {getDomainName(rootFolder.name)} to preview.
                </Typography>
            );
        }

        return data?.map((row) => <ModalItem key={row.id} row={row} isPreview />);
    };

    return (
        <>
            <Stack direction="row" sx={breadcrumbWrapperStyles}>
                <Button
                    endIcon={<NavigateNext />}
                    onClick={resetPreview}
                    size="small"
                    sx={{ padding: 1 }}
                    variant="text"
                >
                    {rootFolder.name}
                </Button>
                <Button disabled size="small" sx={activeBreadcrumbStyles} variant="text">
                    {previewedLocation.name}
                </Button>
            </Stack>
            <Stack sx={contentWrapperStyles}>{renderModalItems()}</Stack>
        </>
    );
};

export default ModalPreviewItem;
